import React from 'react';
import { slide as Menu } from 'react-burger-menu'
import { Link as Scroll } from 'react-scroll';

const MENU_ITEMS = ['Top', 'About', 'Rooms', 'Service', 'Schedule', 'Access', 'News', 'Address', 'Contact']

const BurgerIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="1.4" aria-hidden="true">
        <path d="M4 7h16" />
        <path d="M4 12h16" />
        <path d="M4 17h16" />
    </svg>
)

class Burger extends React.Component {
    state = { isOpen: false }

    scrollSettings = {
        className: 'menu-item',
        smooth: true,
        duration: 1000
    }

    handleStateChange = (state) => {
        this.setState({ isOpen: state.isOpen })
    }

    closeMenu = () => {
        this.setState({ isOpen: false })
    }

    render () {
        return (
            <div id='burger'>
                <Menu
                    customBurgerIcon={ <BurgerIcon /> }
                    isOpen={ this.state.isOpen }
                    onStateChange={ this.handleStateChange }
                    right
                >
                    <p className='title'>Liina Dance Studio</p>
                    <div className='menu-item-wrapper'>
                        {MENU_ITEMS.map((item) => (
                            <Scroll
                                key={item}
                                to={item.toLowerCase()}
                                onClick={this.closeMenu}
                                {...this.scrollSettings}
                            >
                                {item}
                            </Scroll>
                        ))}
                    </div>
                    <div className='contact'>
                        <div className='text'>
                            〒355-0047<br/>
                            埼玉県東松山市高坂1034-7<br/>
                            0493-81-6300<br/>
                            liina.dancestudio@gmail.com
                        </div>
                        <a
                            className='instagram'
                            href='https://www.instagram.com/liina_dancestudio'
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            INSTAGRAM
                        </a>
                    </div>
                </Menu>
            </div>
        )
    }
}

export default Burger
